<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-form ref="form" @submit.prevent="() => $emit('salvar', empresa)">
      <v-card v-if="empresa" :loading="salvando">
        <v-card-title> {{ operacao === 'editar' ? 'Editar' : 'Adicionar' }} Empresa </v-card-title>
        <v-card-text>
          <v-form ref="formDialog" v-model="validForm" @submit.prevent>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="empresa.nome"
                    label="Nome"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <CampoDeCpfOuCnpj
                    v-model="empresa.documento"
                    label="CPF / CNPJ"
                    :disabled="operacao === 'editar'"
                  />
                </v-col>
                <v-col>
                  <v-autocomplete
                    v-model="empresa.uf.id"
                    :items="itens.uf"
                    :rules="[obrigatorio]"
                    label="UF"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-textarea
                    v-model="empresa.observacoes"
                    rows="2"
                    label="Observacao"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-switch v-if="operacao === 'editar'" v-model="empresa.status" label="Ativo" dense />
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-alert v-if="showMessageError" dense outlined type="error">
                    {{ dataError }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" type="button" text @click="dialog = false">Cancelar</v-btn>
          <v-btn
            class="ml-auto"
            type="submit"
            text
            color="success"
            :disabled="!validForm"
            @click="salvar(empresa)"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Empresa from '../../models/empresa'
import EmpresaService from '../../services/empresa/empresa'
import { obrigatorio } from '../../shareds/regrasForm'
import CampoDeCpfOuCnpj from '../ui/CampoDeCpfOuCnpj.vue'

export default {
  components: { CampoDeCpfOuCnpj },
  props: ['showDialog', 'empresaParam', 'operacao', 'itens'],
  data: () => ({
    dialog: false,
    empresa: new Empresa(),
    showMessageError: false,
    obrigatorio: obrigatorio,
    salvando: false,
    validForm: false,
    dataError: ''
  }),
  watch: {
    showDialog() {
      this.showMessageError = false
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },
    empresaParam() {
      return this.empresaParam ? this.initialize() : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    }
  },
  methods: {
    initialize() {
      this.empresa = new Empresa()
      if (this.$refs.formDialog) this.$refs.formDialog.resetValidation()

      this.empresa = this.empresaParam
    },

    async salvar(item) {
      this.salvando = true
      this.showMessageError = false
      try {
        const data = {
          ...item,
          documento: item.documento.replaceAll('.', '').replaceAll('/', '').replaceAll('-', '')
        }

        const empresaSalva =
          this.operacao === 'adicionar'
            ? await EmpresaService.create({ ...data, conferido: false })
            : await EmpresaService.update(data.id, data)

        this.$emit('confirmado', empresaSalva)
        this.dialog = false
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    fecharDialog() {
      this.$emit('update:showDialog', false)
    }
  }
}
</script>
